import { useEffect, useState } from "react";
import { apiPost } from "../utils/apiPost";

let provinceCache = null;
let provincePromise = null;

export function useProvinceOptions() {
  const [provinceOptions, setProvinceOptions] = useState(provinceCache || []);
  const [loading, setLoading] = useState(!provinceCache);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (provinceCache) {
      setLoading(false);
      return;
    }

    if (!provincePromise) {
      provincePromise = apiPost({
        cat: "Geografia",
        met: "GetProvince",
        np: 1,
        body: JSON.stringify({
          IdNazione: 63,
        }),
      })
        .then((res) => {
          const mapped = res.data
            .map((province) => ({
              value: province.Provincia,
              label: province.Provincia,
            }))
            .sort((a, b) => a.label.localeCompare(b.label));

          provinceCache = mapped;
          return mapped;
        });
    }

    provincePromise
      .then((data) => {
        setProvinceOptions(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Errore nel recupero province:", err);
        setError(err);
        setLoading(false);
      });
  }, []);

  return { provinceOptions, loading, error };
}